import { useDispatch } from 'react-redux'
import { useCallback, useState } from 'react'

import useComplexActions from 'app/dataProviders/complexes/single/hooks/useComplexActions'
import useCallbackRef from 'app/common/hooks/useCallbackRef'
import { kitsNeedUpdate } from 'app/actions/orgs/kits/options'
import usePopup from 'app/common/hooks/usePopup'
import { DietFoodTypeId } from 'app/dataTypes/org/dietFoodTypes'

type Options = {
  orgID: string
  complexID: string
  buildingId?: number
  dietFoodTypeId?: DietFoodTypeId
}

export default function useSubmit({
  orgID,
  complexID,
  buildingId,
  dietFoodTypeId,
}: Options): [boolean, (form: HTMLFormElement) => Promise<boolean>] {
  const dispatch = useDispatch()
  const popup = usePopup()

  const [submitting, setSubmitting] = useState(false)
  const { submit: submitComplex } = useComplexActions({ orgID, complexID })
  const submitComplexRef = useCallbackRef(submitComplex)

  const submit = useCallback(
    async (form: HTMLFormElement) => {
      const formData = new FormData(form)
      setSubmitting(true)
      const fundMovement = formData.get('fundMovementTypeCode')?.toString() as string
      const fundMovementTypeCode = fundMovement ? parseInt(fundMovement, 10) : null
      const buffetZone = !!formData.get('buffetZone')
      const hotMealsZone = !!formData.get('hotMealsZone')
      const denyParentMoneySales = !!formData.get('denyParentMoneySales')
      const denyMoreThanOneSales = !!formData.get('denyMoreThanOneSales')
      const disableForTerminalGuestSales = !!formData.get('disableForTerminalGuestSales')
      const useAsAdditional = !!formData.get('useAsAdditional')

      const res = await submitComplexRef.current?.({
        buffetZone,
        hotMealsZone,
        denyParentMoneySales,
        denyMoreThanOneSales,
        disableForTerminalGuestSales,
        useAsAdditional,
        fundMovementTypeCode,
        buildingId,
        dietFoodTypeId,
      })
      setSubmitting(false)

      if (res) {
        popup('Настройки успешно применены')
        dispatch(kitsNeedUpdate(true))
      }

      return !!res
    },
    [submitComplexRef, buildingId, dietFoodTypeId, popup, dispatch],
  )

  return [submitting, submit]
}
